import { EventContext, LookupContext } from "@gp/components";
import { observer } from "mobx-react";
import React, { useContext } from "react";

import OfferIcon from "@components/icons/Offer";
import { useOfferOptionsContext } from "@state/hooks/offer/useOfferOptionsContext";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";

export const MatchIconAndName = observer(function MatchIconAndName() {
	const lookupContext = useContext(LookupContext);
	const event = useContext(EventContext);
	const options = useOfferOptionsContext();
	const offerStore = useOfferContext();

	const sport = lookupContext.sports.get(event.sportId);
	const category = lookupContext.categories.get(event.sportCategoryId);
	const tournament = lookupContext.tournaments.get(event.tournamentId);

	if (sport == null) {
		console.error("Expected sport, got null.");
		return null;
	}

	if (category == null) {
		console.error("Expected category, got null.");
		return null;
	}

	if (tournament == null) {
		console.error("Expected tournament, got null.");
		return null;
	}

	if (
		options.hideTournamentDescriptionIfSingleTournament &&
		offerStore.shouldHideTournamentNameAndCategory
	) {
		return null;
	}

	return (
		<span className="match__details__ct">
			<OfferIcon
				type={"tournament"}
				sport={sport.abrv}
				category={category.abrv}
				tournament={tournament.abrv}
				wrapperClassName="match__icon--category u-icon u-icon--sml u-mar--right--nano"
				className="u-icon--sml u-icon--round"
			/>
			{category.name}
			<span className="u-mar--x--micro">/</span>
			{tournament.name}
		</span>
	);
});
